// import { useState } from "react";
// import Header from "./Header/Header";
// import Sidebar from "./Sidebar/Sidebar";
// import { IoSearch } from "react-icons/io5";
// import mrkt_card_icontop from "../assets/mrkt_card_icontop.webp";
// import mrkt_card_icontop2 from "../assets/mrkt_card_icontop2.webp";
// import mrkt_card_icontop3 from "../assets/mrkt_card_icontop3.webp";
// import mrkt_card_icontop4 from "../assets/mrkt_card_icontop4.webp";
// import mrkt_card_icontop5 from "../assets/mrkt_card_icontop5.webp";
// import mrkt_card_icontop6 from "../assets/mrkt_card_icontop6.webp";
// import mrkt_card_icontop7 from "../assets/mrkt_card_icontop7.webp";
// import mrkt_card_icontop8 from "../assets/mrkt_card_icontop8.webp";
// import market_card_img from "../assets/market_card_img.webp";
// import market_card_img2 from "../assets/market_card_img2.webp";
// import market_card_img3 from "../assets/market_card_img3.webp";
// import market_card_img4 from "../assets/market_card_img4.webp";
// import market_card_img5 from "../assets/market_card_img5.webp";
// import market_card_img6 from "../assets/market_card_img6.webp";
// import market_card_img7 from "../assets/market_card_img7.webp";
// import market_card_img8 from "../assets/market_card_img8.webp";

// import mrktBond_icon from "../assets/mrktBond_icon.webp"
// import mrktBond_icon2 from "../assets/mrktBond_icon2.webp"
// import mrktBond_icon3 from "../assets/mrktBond_icon3.webp"
// import mrktBond_icon4 from "../assets/mrktBond_icon4.webp"
// import mrktBond_card_img from "../assets/mrktBond_card_img.webp";
// import mrktBond_card_img2 from "../assets/mrktBond_card_img2.webp";
// import mrktBond_card_img3 from "../assets/mrktBond_card_img3.webp";
// import mrktBond_card_img4 from "../assets/mrktBond_card_img4.webp";

// import mrktPrivate_icon from "../assets/mrktPrivate_icon.webp"
// import mrktPrivate_icon2 from "../assets/mrktPrivate_icon2.webp"
// import mrktPrivate_icon3 from "../assets/mrktPrivate_icon3.webp"
// import mrktPrivate_icon4 from "../assets/mrktPrivate_icon4.webp"
// import mrktPrivate_card_img from "../assets/mrktPrivate_card_img.webp";
// import mrktPrivate_card_img2 from "../assets/mrktPrivate_card_img2.webp";
// import mrktPrivate_card_img3 from "../assets/mrktPrivate_card_img3.webp";
// import mrktPrivate_card_img4 from "../assets/mrktPrivate_card_img4.webp";

// import mrktCommdty_icon from "../assets/mrktCommdty_icon.webp"
// import mrktCommdty_icon2 from "../assets/mrktCommdty_icon2.webp"
// import mrktCommdty_icon3 from "../assets/mrktCommdty_icon3.webp"
// import mrktCommdty_icon4 from "../assets/mrktCommdty_icon4.webp"
// import mrktCommdty_card_img from "../assets/mrktCommdty_card_img.webp";
// import mrktCommdty_card_img2 from "../assets/mrktCommdty_card_img2.webp";
// import mrktCommdty_card_img3 from "../assets/mrktCommdty_card_img3.webp";
// import mrktCommdty_card_img4 from "../assets/mrktCommdty_card_img4.webp";

// import mrktEquity_icon from "../assets/mrktEquity_icon.webp"
// import mrktEquity_icon2 from "../assets/mrktEquity_icon2.webp"
// import mrktEquity_icon3 from "../assets/mrktEquity_icon3.webp"
// import mrktEquity_icon4 from "../assets/mrktEquity_icon4.webp"
// import mrktEquity_card_img from "../assets/mrktEquity_card_img.webp";
// import mrktEquity_card_img2 from "../assets/mrktEquity_card_img2.webp";
// import mrktEquity_card_img3 from "../assets/mrktEquity_card_img3.webp";
// import mrktEquity_card_img4 from "../assets/mrktEquity_card_img4.webp";

// import Footer from "./Footer/Footer";
// import { Link } from "react-router-dom";

// const Market = () => {
//   const [sortFilter, setSortFilter] = useState("APY %");

//   const handleSortBy = (e) => {
//     console.log(e.target.innerText.toLowerCase(), "iiuh");
//     setSortFilter(e.target.innerText.toLowerCase());
//   };

//   const marketItem = [
//     {
//       logoImg: mrkt_card_icontop5,
//       cardTitle: "Value Infi",
//       cardImg: market_card_img5,
//       cardSubTitle: "Private Villa Collection",
//       description:
//         "Exclusive luxury villas tokenized for fractional global ownership.",
//       details: [
//         { label: "Asset Class", value: "Private Equity" },
//         { label: "Target Returns", value: "7.00% p.a." },
//         { label: "Fund Term", value: "3 - Months" },
//         { label: "Min.Invesment", value: "USD 3,000" },
//       ],
//       buttonText: "Invest Now",
//       activeStatus:false,
//     },
//     {
//       logoImg: mrkt_card_icontop6,
//       cardTitle: "MetroBlocks",
//       cardImg: market_card_img6,
//       cardSubTitle: "Urban Residential Fund",
//       description:
//         "Fractionalized access to multi-family apartments in fast-growing US cities.",
//       details: [
//         { label: "Asset Class", value: "Real Estate Equity" },
//         { label: "Target Returns", value: "8.00% p.a." },
//         { label: "Fund Term", value: "6 - Months" },
//         { label: "Min.Invesment", value: "USD 7,000" },
//       ],
//       buttonText: "Invest Now",
//       activeStatus:false,
//     },
//     {
//       logoImg: mrkt_card_icontop7,
//       cardTitle: " Harbor Heights",
//       cardImg: market_card_img7,
//       cardSubTitle: "Waterfront Properties Fund",
//       description:
//         "Tokenized luxury condos and villas near premium US waterfront locations.",
//       details: [
//         { label: "Asset Class", value: "Private Equity" },
//         { label: "Target Returns", value: "10.00% p.a." },
//         { label: "Fund Term", value: "9 - Months" },
//         { label: "Min.Invesment", value: "USD 9,000" },
//       ],
//       buttonText: "Invest Now",
//       activeStatus:false,
//     },
//     {
//       logoImg: mrkt_card_icontop8,
//       cardTitle: " Capital Square",
//       cardImg: market_card_img8,
//       cardSubTitle: "Mixed-Use Real Estate Fund",
//       description:
//         "Tokenized access to retail, office, and residential spaces in high-demand US cities.",
//       details: [
//         { label: "Asset Class", value: "Real Estate Equity" },
//         { label: "Target Returns", value: "8.80% p.a." },
//         { label: "Fund Term", value: "12 - Months" },
//         { label: "Min.Invesment", value: "USD 3,500" },
//       ],
//       buttonText: "Invest Now",
//       activeStatus:false,
//     },
//     {
//       logoImg: mrkt_card_icontop,
//       cardTitle: "Urbon Blocks",
//       cardImg: market_card_img,
//       cardSubTitle: "Global Real Estate Fund",
//       description:
//         "A flagship tokenized real estate fund, transforming premium properties into accessible digital tokens.",
//       details: [
//         { label: "Asset Class", value: "Private Equity" },
//         { label: "Target Returns", value: "10 - 12% p.a." },
//         { label: "Fund Term", value: "Open-ended" },
//         { label: "Min.Invesment", value: "USD 5,000" },
//       ],
//       buttonText: "Invest Now",
//       activeStatus:true,
//     },
//     {
//       logoImg: mrkt_card_icontop2,
//       cardTitle: "Value Infi",
//       cardImg: market_card_img2,
//       cardSubTitle: "Private villa",
//       description:
//         "An exclusive private villa through secure tokenization, combining luxury real estate with global accessibility.",
//       details: [
//         { label: "Asset Class", value: "Private Equity" },
//         { label: "Target Returns", value: "7.00% p.a." },
//         { label: "Fund Term", value: "3 - Months" },
//         { label: "Min.Invesment", value: "USD 3,000" },
//       ],
//       buttonText: "Invest Now",
//       activeStatus:true,
//     },
//     {
//       logoImg: mrkt_card_icontop3,
//       cardTitle: "Maxi Group",
//       cardImg: market_card_img3,
//       cardSubTitle: "Commercial Estate Fund",
//       description:
//         "A tokenized commercial asset fund featuring premium villas, offering investors stable yields, secure ownership, and global accessibility.",
//       details: [
//         { label: "Asset Class", value: "Commercial Equity" },
//         { label: "Target Returns", value: "10.33% p.a." },
//         { label: "Fund Term", value: "2 - Months" },
//         { label: "Min.Invesment", value: "USD 2,000" },
//       ],
//       buttonText: "Invest Now",
//       activeStatus:true,
//     },
//     {
//       logoImg: mrkt_card_icontop4,
//       cardTitle: "Skyline Towers",
//       cardImg: market_card_img4,
//       cardSubTitle: "Commercial Estate Fund",
//       description:
//         "High-rise commercial buildings across US metro cities, generating rental income.",
//       details: [
//         { label: "Asset Class", value: "Commercial Equity" },
//         { label: "Target Returns", value: "8.50% p.a." },
//         { label: "Fund Term", value: "12 - Months" },
//         { label: "Min.Invesment", value: "USD 3,000" },
//       ],
//       buttonText: "Invest Now",
//       activeStatus:true,
//     },
//   ];

//   const TreasuriresItem = [
//     {
//       logoImg: mrktBond_icon,
//       cardTitle: "BondTrust Capital",
//       cardImg: mrktBond_card_img,
//       cardSubTitle: "Tokenized U.S. Treasury Fund",
//       description:
//         "Fractional access to short-term U.S. government bonds, providing a safe and liquid yield option.",
//       details: [
//         { label: "Asset Class", value: "Treasuries" },
//         { label: "Target Returns", value: "4–5% p.a" },
//         { label: "Fund Term", value: "Open-ended" },
//         { label: "Min.Invesment", value: "USD 500" },
//       ],
//       buttonText: "Invest Now",
//       activeStatus:false,
//     },
//     {
//       logoImg: mrktBond_icon2,
//       cardTitle: "CivicYield",
//       cardImg: mrktBond_card_img2,
//       cardSubTitle: "Municipal Bond Token Fund",
//       description:
//         " Diversified portfolio of tokenized U.S. municipal bonds, supporting infrastructure and community projects.",
//       details: [
//         { label: "Asset Class", value: "Municipal Bonds" },
//         { label: "Target Returns", value: "3–4% p.a." },
//         { label: "Fund Term", value: "1 - years" },
//         { label: "Min.Invesment", value: "USD 1,000" },
//       ],
//       buttonText: "Invest Now",
//       activeStatus:false,
//     },
//     {
//       logoImg: mrktBond_icon3,
//       cardTitle: " CorporateEdge",
//       cardImg: mrktBond_card_img3,
//       cardSubTitle: "Corporate Bond Yield Fund",
//       description:
//         "Exposure to investment-grade corporate debt via blockchain-based tokenization.",
//       details: [
//         { label: "Asset Class", value: "Corporate Bonds" },
//         { label: "Target Returns", value: "5–6% p.a." },
//         { label: "Fund Term", value: "3 - years" },
//         { label: "Min.Invesment", value: "USD 2,000" },
//       ],
//       buttonText: "Invest Now",
//       activeStatus:false,
//     },
//     {
//       logoImg: mrktBond_icon4,
//       cardTitle: "SovereignGate",
//       cardImg: mrktBond_card_img4,
//       cardSubTitle: "Sovereign Bond Token Fund",
//       description:
//         "Global portfolio of sovereign government bonds, digitally issued and tradable.",
//       details: [
//         { label: "Asset Class", value: "Sovereign Bondsy" },
//         { label: "Target Returns", value: "4–6% p.a." },
//         { label: "Fund Term", value: "7 - years" },
//         { label: "Min.Invesment", value: "USD 5,000" },
//       ],
//       buttonText: "Invest Now",
//       activeStatus:false,
//     }
//   ];

//   const privateCreditItem = [
//     {
//       logoImg: mrktPrivate_icon,
//       cardTitle: "Lendwise Partners",
//       cardImg: mrktPrivate_card_img,
//       cardSubTitle: "Direct Lending Token Fund",
//       description:
//         "Tokenized exposure to private loans made to mid-market companies.",
//       details: [
//         { label: "Asset Class", value: "Direct Lending" },
//         { label: "Target Returns", value: "9–11% p.a." },
//         { label: "Fund Term", value: "5 - years" },
//         { label: "Min.Invesment", value: "USD 500" },
//       ],
//       buttonText: "Invest Now",
//       activeStatus:false,
//     },
//     {
//       logoImg: mrktPrivate_icon2,
//       cardTitle: "BridgePoint Capital",
//       cardImg: mrktPrivate_card_img2,
//       cardSubTitle: "Mezzanine Debt Token Fund",
//       description:
//         " Hybrid debt-equity investments with higher yields, tokenized for investor access.",
//       details: [
//         { label: "Asset Class", value: "Private Credit" },
//         { label: "Target Returns", value: "12–14% p.a." },
//         { label: "Fund Term", value: "6 - years" },
//         { label: "Min.Invesment", value: "USD 10,000" },
//       ],
//       buttonText: "Invest Now",
//       activeStatus:false,
//     },
//     {
//       logoImg: mrktPrivate_icon3,
//       cardTitle: " AssetCore Lending",
//       cardImg: mrktPrivate_card_img3,
//       cardSubTitle: "Asset-Backed Lending Fund",
//       description:
//         "Tokenized loans secured by physical collateral (equipment, receivables).",
//       details: [
//         { label: "Asset Class", value: "Asset-Backed" },
//         { label: "Target Returns", value: "10% p.a." },
//         { label: "Fund Term", value: "4 - years" },
//         { label: "Min.Invesment", value: "USD 3,000" },
//       ],
//       buttonText: "Invest Now",
//       activeStatus:false,
//     },
//     {
//       logoImg: mrktPrivate_icon4,
//       cardTitle: "Turnaround Capital",
//       cardImg: mrktPrivate_card_img4,
//       cardSubTitle: "Distressed Debt Opportunities Fund",
//       description:
//         "Digital-first access to distressed corporate debt with turnaround potential.",
//       details: [
//         { label: "Asset Class", value: "Private Credit" },
//         { label: "Target Returns", value: "18% p.a." },
//         { label: "Fund Term", value: "7 - years" },
//         { label: "Min.Invesment", value: "USD 20,000" },
//       ],
//       buttonText: "Invest Now",
//       activeStatus:false,
//     }
//   ];

//   const commditiesItem = [
//     {
//       logoImg: mrktCommdty_icon,
//       cardTitle: "Aurora Gold Trust",
//       cardImg: mrktCommdty_card_img,
//       cardSubTitle: " Tokenized Gold Reserve Fund",
//       description:
//         "Fractionalized ownership of vaulted gold, tokenized for liquidity and transparency.",
//       details: [
//         { label: "Asset Class", value: "Precious Metals" },
//         { label: "Target Returns", value: "7% p.a." },
//         { label: "Fund Term", value: "Open-ended" },
//         { label: "Min.Invesment", value: "USD 500" },
//       ],
//       buttonText: "Invest Now",
//       activeStatus:false,
//     },
//     {
//       logoImg: mrktCommdty_icon2,
//       cardTitle: "PetroFlow Fund",
//       cardImg: mrktCommdty_card_img2,
//       cardSubTitle: "Energy Token Fund",
//       description:
//         " Exposure to tokenized oil and natural gas reserves with real-world yield.",
//       details: [
//         { label: "Asset Class", value: " Commodities (Energy)" },
//         { label: "Target Returns", value: "12% p.a." },
//         { label: "Fund Term", value: "6 - years" },
//         { label: "Min.Invesment", value: "USD 2,500" },
//       ],
//       buttonText: "Invest Now",
//       activeStatus:false,
//     },
//     {
//       logoImg: mrktCommdty_icon3,
//       cardTitle: " AgriHarvest",
//       cardImg: mrktCommdty_card_img3,
//       cardSubTitle: "Agri-Token Fund",
//       description:
//         "Tokenized agricultural commodities (wheat, corn, soybeans) with global market exposure.",
//       details: [
//         { label: "Asset Class", value: "Agriculture" },
//         { label: "Target Returns", value: "9% p.a." },
//         { label: "Fund Term", value: "3 - years" },
//         { label: "Min.Invesment", value: "USD 1,000" },
//       ],
//       buttonText: "Invest Now",
//       activeStatus:false,
//     },
//     {
//       logoImg: mrktCommdty_icon4,
//       cardTitle: "MetalStream Capital",
//       cardImg: mrktCommdty_card_img4,
//       cardSubTitle: " Industrial Metals Token Fund",
//       description:
//         "Access to tokenized industrial metals like copper and aluminum.",
//       details: [
//         { label: "Asset Class", value: "Commodities (Industrial Metals)" },
//         { label: "Target Returns", value: "10% p.a." },
//         { label: "Fund Term", value: "5 - years" },
//         { label: "Min.Invesment", value: "USD 3,000" },
//       ],
//       buttonText: "Invest Now",
//       activeStatus:false,
//     }
//   ];

//   const equityItem = [
//     {
//       logoImg: mrktEquity_icon,
//       cardTitle: "BluePeak Global",
//       cardImg: mrktEquity_card_img,
//       cardSubTitle: " Global Blue-Chip Token Fund",
//       description:
//         "Fractionalized ownership of top global equities like Apple, Microsoft, Amazon.",
//       details: [
//         { label: "Asset Class", value: "Large Cap" },
//         { label: "Target Returns", value: "9% p.a." },
//         { label: "Fund Term", value: "Open-ended" },
//         { label: "Min.Invesment", value: "USD 500" },
//       ],
//       buttonText: "Invest Now",
//       activeStatus:false,
//     },
//     {
//       logoImg: mrktEquity_icon2,
//       cardTitle: "Emergia Growth",
//       cardImg: mrktEquity_card_img2,
//       cardSubTitle: "Emerging Markets Equity Token Fund",
//       description:
//         " Tokenized exposure to high-growth equities in Asia, Africa, and Latin America.",
//       details: [
//         { label: "Asset Class", value: " Equities (Emerging Markets)" },
//         { label: "Target Returns", value: "10–13% p.a." },
//         { label: "Fund Term", value: "7 - years" },
//         { label: "Min.Invesment", value: "USD 2,000" },
//       ],
//       buttonText: "Invest Now",
//       activeStatus:false,
//     },
//     {
//       logoImg: mrktEquity_icon3,
//       cardTitle: " Grop REITs",
//       cardImg: mrktEquity_card_img3,
//       cardSubTitle: "Tokenized REIT Growth Fund",
//       description:
//         "Exposure to investment-grade corporate debt via blockchain-based tokenization.",
//       details: [
//         { label: "Asset Class", value: "Corporate Bonds" },
//         { label: "Target Returns", value: "10% p.a." },
//         { label: "Fund Term", value: "Open-ended" },
//         { label: "Min.Invesment", value: "USD 1,000" },
//       ],
//       buttonText: "Invest Now",
//       activeStatus:false,
//     },
//     {
//       logoImg: mrktEquity_icon4,
//       cardTitle: "Private sifi",
//       cardImg: mrktEquity_card_img4,
//       cardSubTitle: " Private Equity Token Fund",
//       description:
//         "Equity exposure to tokenized Real Estate Investment Trusts (REITs).",
//       details: [
//         { label: "Asset Class", value: "REITs" },
//         { label: "Target Returns", value: "15% p.a." },
//         { label: "Fund Term", value: "8 - years" },
//         { label: "Min.Invesment", value: "USD 10,000" },
//       ],
//       buttonText: "Invest Now",
//       activeStatus:false,
//     }
//   ];

//   return (
//     <>
//       <Header />

//       <main className="main_flx">
//         <Sidebar />

//         <div className="right_wrap market_wrap_main">
//           <div className="market_tab_wrp">
//             <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
//               <li className="nav-item" role="presentation">
//                 <button
//                   className="nav-link active"
//                   id="pills-Real-Estate-tab"
//                   data-bs-toggle="pill"
//                   data-bs-target="#pills-Real-Estate"
//                   type="button"
//                   role="tab"
//                   aria-controls="pills-Real-Estate"
//                   aria-selected="true"
//                 >
//                   Real Estate
//                 </button>
//               </li>
//               <li className="nav-item" role="presentation">
//                 <button
//                   className="nav-link"
//                   id="pills-Treasuries-Bonds-tab"
//                   data-bs-toggle="pill"
//                   data-bs-target="#pills-Treasuries-Bonds"
//                   type="button"
//                   role="tab"
//                   aria-controls="pills-Treasuries-Bonds"
//                   aria-selected="false"
//                 >
//                   Treasuries & Bonds
//                 </button>
//               </li>
//               <li className="nav-item" role="presentation">
//                 <button
//                   className="nav-link"
//                   id="pills-Private-Credit-tab"
//                   data-bs-toggle="pill"
//                   data-bs-target="#pills-Private-Credit"
//                   type="button"
//                   role="tab"
//                   aria-controls="pills-Private-Credit"
//                   aria-selected="false"
//                 >
//                   Private Credit
//                 </button>
//               </li>
//               <li className="nav-item" role="presentation">
//                 <button
//                   className="nav-link"
//                   id="pills-Commodities-tab"
//                   data-bs-toggle="pill"
//                   data-bs-target="#pills-Commodities"
//                   type="button"
//                   role="tab"
//                   aria-controls="pills-Commodities"
//                   aria-selected="false"
//                 >
//                   Commodities
//                 </button>
//               </li>
//               <li className="nav-item" role="presentation">
//                 <button
//                   className="nav-link"
//                   id="pills-Equities-tab"
//                   data-bs-toggle="pill"
//                   data-bs-target="#pills-Equities"
//                   type="button"
//                   role="tab"
//                   aria-controls="pills-Equities"
//                   aria-selected="false"
//                 >
//                   Equities
//                 </button>
//               </li>
//             </ul>

//             <div className="search_select_wrp">
//               <div className="select_main">
//                 <div className="dropdown">
//                   <button
//                     className="btn btn-secondary dropdown-toggle"
//                     type="button"
//                     id="dropdownMenuButton1"
//                     data-bs-toggle="dropdown"
//                     aria-expanded="false"
//                   >
//                     Sort by : <span>{sortFilter}</span>
//                   </button>
//                   <ul
//                     className="dropdown-menu"
//                     aria-labelledby="dropdownMenuButton1"
//                   >
//                     <li>
//                       <a
//                         className="dropdown-item"
//                         href="#"
//                         onClick={handleSortBy}
//                       >
//                         APY %
//                       </a>
//                     </li>
//                     <li>
//                       <a
//                         className="dropdown-item"
//                         href="#"
//                         onClick={handleSortBy}
//                       >
//                         Latest
//                       </a>
//                     </li>
//                     <li>
//                       <a
//                         className="dropdown-item"
//                         href="#"
//                         onClick={handleSortBy}
//                       >
//                         Market Cap
//                       </a>
//                     </li>
//                     <li>
//                       <a
//                         className="dropdown-item"
//                         href="#"
//                         onClick={handleSortBy}
//                       >
//                         Alphabetical
//                       </a>
//                     </li>
//                   </ul>
//                 </div>
//               </div>

//               <div className="search_main">
//                 <input src="text" placeholder="Search" />
//                 <IoSearch />
//               </div>
//             </div>
//           </div>

//           <div className="market_tab_content">
//             <div className="tab-content" id="pills-tabContent">
//               <div
//                 className="tab-pane fade show active"
//                 id="pills-Real-Estate"
//                 role="tabpanel"
//                 aria-labelledby="pills-Real-Estate-tab"
//               >

//                 <div className="dsh_inv_grid market_card_row">
//                   {marketItem.map((item) => (
//                     <div key={item.id} className="dsh_inv_card market_card">
//                       <div className="dsh_inv_head">
//                         <div className="dsh_inv_top mrkt_top_title">
//                           <div className="mrkt_top_content">
//                             <img
//                             className="img_div"
//                             src={item.logoImg}
//                             alt={item.title}
//                           />
//                           <h6>{item.cardTitle}</h6>
//                           </div>

//                           { item.activeStatus ? <span className="mrkt_sts">Active</span> : ''}
//                         </div>
//                         <img src={item.cardImg} alt={item.title} />
//                         <div className="mrkt_main_cd_tlt">
//                           <h3>{item.cardTitle}</h3>
//                           <h5>{item.cardSubTitle}</h5>
//                           <p>{item.description}</p>
//                         </div>

//                         <div className="dsh_inv_card_cnt">
//                           <div className="dsh_inv_cd_flx">
//                             {item.details.slice(0, 2).map((d, i) => (
//                               <div key={i} className="dsh_inv_cd_lft">
//                                 <span>{d.label}</span>
//                                 <h4>{d.value}</h4>
//                               </div>
//                             ))}
//                           </div>
//                           <div className="dsh_inv_cd_flx mt-4">
//                             {item.details.slice(2, 4).map((d, i) => (
//                               <div key={i} className="dsh_inv_cd_lft">
//                                 <span>{d.label}</span>
//                                 <h4>{d.value}</h4>
//                               </div>
//                             ))}
//                           </div>
//                         </div>
//                       </div>
//                       <button className="dsh_inv_btn">
//                         <Link to={"/marketDetais"}>{item.buttonText}</Link>
//                       </button>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//               <div
//                 className="tab-pane fade"
//                 id="pills-Treasuries-Bonds"
//                 role="tabpanel"
//                 aria-labelledby="pills-Treasuries-Bonds-tab"
//               >
//                 <div className="dsh_inv_grid market_card_row">
//                   {TreasuriresItem.map((item) => (
//                     <div key={item.id} className="dsh_inv_card market_card">
//                       <div className="dsh_inv_head">
//                         <div className="dsh_inv_top mrkt_top_title">
//                           <div className="mrkt_top_content">
//                             <img
//                             className="img_div"
//                             src={item.logoImg}
//                             alt={item.title}
//                           />
//                           <h6>{item.cardTitle}</h6>
//                           </div>

//                           { item.activeStatus ? <span className="mrkt_sts">Active</span> : ''}
//                         </div>
//                         <img src={item.cardImg} alt={item.title} />
//                         <div className="mrkt_main_cd_tlt">
//                           <h3>{item.cardTitle}</h3>
//                           <h5>{item.cardSubTitle}</h5>
//                           <p>{item.description}</p>
//                         </div>

//                         <div className="dsh_inv_card_cnt">
//                           <div className="dsh_inv_cd_flx">
//                             {item.details.slice(0, 2).map((d, i) => (
//                               <div key={i} className="dsh_inv_cd_lft">
//                                 <span>{d.label}</span>
//                                 <h4>{d.value}</h4>
//                               </div>
//                             ))}
//                           </div>
//                           <div className="dsh_inv_cd_flx mt-4">
//                             {item.details.slice(2, 4).map((d, i) => (
//                               <div key={i} className="dsh_inv_cd_lft">
//                                 <span>{d.label}</span>
//                                 <h4>{d.value}</h4>
//                               </div>
//                             ))}
//                           </div>
//                         </div>
//                       </div>
//                       <button className="dsh_inv_btn">
//                         <Link to={"/marketDetais"}>{item.buttonText}</Link>
//                       </button>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//               <div
//                 className="tab-pane fade"
//                 id="pills-Private-Credit"
//                 role="tabpanel"
//                 aria-labelledby="pills-Private-Credit-tab"
//               >
//                 <div className="dsh_inv_grid market_card_row">
//                   {privateCreditItem.map((item) => (
//                     <div key={item.id} className="dsh_inv_card market_card">
//                       <div className="dsh_inv_head">
//                         <div className="dsh_inv_top mrkt_top_title">
//                           <div className="mrkt_top_content">
//                             <img
//                             className="img_div"
//                             src={item.logoImg}
//                             alt={item.title}
//                           />
//                           <h6>{item.cardTitle}</h6>
//                           </div>

//                           { item.activeStatus ? <span className="mrkt_sts">Active</span> : ''}
//                         </div>
//                         <img src={item.cardImg} alt={item.title} />
//                         <div className="mrkt_main_cd_tlt">
//                           <h3>{item.cardTitle}</h3>
//                           <h5>{item.cardSubTitle}</h5>
//                           <p>{item.description}</p>
//                         </div>

//                         <div className="dsh_inv_card_cnt">
//                           <div className="dsh_inv_cd_flx">
//                             {item.details.slice(0, 2).map((d, i) => (
//                               <div key={i} className="dsh_inv_cd_lft">
//                                 <span>{d.label}</span>
//                                 <h4>{d.value}</h4>
//                               </div>
//                             ))}
//                           </div>
//                           <div className="dsh_inv_cd_flx mt-4">
//                             {item.details.slice(2, 4).map((d, i) => (
//                               <div key={i} className="dsh_inv_cd_lft">
//                                 <span>{d.label}</span>
//                                 <h4>{d.value}</h4>
//                               </div>
//                             ))}
//                           </div>
//                         </div>
//                       </div>
//                       <button className="dsh_inv_btn">
//                         <Link to={"/marketDetais"}>{item.buttonText}</Link>
//                       </button>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//               <div
//                 className="tab-pane fade"
//                 id="pills-Commodities"
//                 role="tabpanel"
//                 aria-labelledby="pills-Commodities-tab"
//               >
//                 <div className="dsh_inv_grid market_card_row">
//                   {commditiesItem.map((item) => (
//                     <div key={item.id} className="dsh_inv_card market_card">
//                       <div className="dsh_inv_head">
//                         <div className="dsh_inv_top mrkt_top_title">
//                           <div className="mrkt_top_content">
//                             <img
//                             className="img_div"
//                             src={item.logoImg}
//                             alt={item.title}
//                           />
//                           <h6>{item.cardTitle}</h6>
//                           </div>

//                           { item.activeStatus ? <span className="mrkt_sts">Active</span> : ''}
//                         </div>
//                         <img src={item.cardImg} alt={item.title} />
//                         <div className="mrkt_main_cd_tlt">
//                           <h3>{item.cardTitle}</h3>
//                           <h5>{item.cardSubTitle}</h5>
//                           <p>{item.description}</p>
//                         </div>

//                         <div className="dsh_inv_card_cnt">
//                           <div className="dsh_inv_cd_flx">
//                             {item.details.slice(0, 2).map((d, i) => (
//                               <div key={i} className="dsh_inv_cd_lft">
//                                 <span>{d.label}</span>
//                                 <h4>{d.value}</h4>
//                               </div>
//                             ))}
//                           </div>
//                           <div className="dsh_inv_cd_flx mt-4">
//                             {item.details.slice(2, 4).map((d, i) => (
//                               <div key={i} className="dsh_inv_cd_lft">
//                                 <span>{d.label}</span>
//                                 <h4>{d.value}</h4>
//                               </div>
//                             ))}
//                           </div>
//                         </div>
//                       </div>
//                       <button className="dsh_inv_btn">
//                         <Link to={"/marketDetais"}>{item.buttonText}</Link>
//                       </button>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//               <div
//                 className="tab-pane fade"
//                 id="pills-Equities"
//                 role="tabpanel"
//                 aria-labelledby="pills-Equities-tab"
//               >
//                 <div className="dsh_inv_grid market_card_row">
//                   {equityItem.map((item) => (
//                     <div key={item.id} className="dsh_inv_card market_card">
//                       <div className="dsh_inv_head">
//                         <div className="dsh_inv_top mrkt_top_title">
//                           <div className="mrkt_top_content">
//                             <img
//                             className="img_div"
//                             src={item.logoImg}
//                             alt={item.title}
//                           />
//                           <h6>{item.cardTitle}</h6>
//                           </div>

//                           { item.activeStatus ? <span className="mrkt_sts">Active</span> : ''}
//                         </div>
//                         <img src={item.cardImg} alt={item.title} />
//                         <div className="mrkt_main_cd_tlt">
//                           <h3>{item.cardTitle}</h3>
//                           <h5>{item.cardSubTitle}</h5>
//                           <p>{item.description}</p>
//                         </div>

//                         <div className="dsh_inv_card_cnt">
//                           <div className="dsh_inv_cd_flx">
//                             {item.details.slice(0, 2).map((d, i) => (
//                               <div key={i} className="dsh_inv_cd_lft">
//                                 <span>{d.label}</span>
//                                 <h4>{d.value}</h4>
//                               </div>
//                             ))}
//                           </div>
//                           <div className="dsh_inv_cd_flx mt-4">
//                             {item.details.slice(2, 4).map((d, i) => (
//                               <div key={i} className="dsh_inv_cd_lft">
//                                 <span>{d.label}</span>
//                                 <h4>{d.value}</h4>
//                               </div>
//                             ))}
//                           </div>
//                         </div>
//                       </div>
//                       <button className="dsh_inv_btn">
//                         <Link to={"/marketDetais"}>{item.buttonText}</Link>
//                       </button>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="mt-5">
//             <Footer />
//           </div>
//         </div>
//       </main>
//     </>
//   );
// };

// export default Market;

import { useState, useEffect } from "react";
import Header from "./Header/Header";
import Sidebar from "./Sidebar/Sidebar";
import { IoSearch } from "react-icons/io5";
import Footer from "./Footer/Footer";
import { Link } from "react-router-dom";

import { Oval } from "react-loader-spinner";
import apiService from "../core/Service/detail";
import { postMethod } from "../core/service/common.api";
import MarketSkeleton from "./MarketSkeleton";

const Market = () => {
  const [sortFilter, setSortFilter] = useState("APY %");
  const [searchTerm, setSearchTerm] = useState("");
  const [tokens, setTokens] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch tokens from API
  const fetchTokens = async () => {
    try {
      setLoading(true);
      setError(null);

      const data = {
        apiUrl: apiService.getAllTokens,
        payload: {
          status: "active", // Only fetch active tokens
          page: 1,
          limit: 50, // Adjust based on your needs
        },
      };

      const resp = await postMethod(data);

      if (resp.status === true) {
        setTokens(resp.data || []);
      } else {
        setError(resp.message || "Failed to fetch tokens");
        // Fallback to mock data if API fails
        setTokens(getMockTokens());
      }
    } catch (err) {
      console.error("Error fetching tokens:", err);
      setError("Failed to load tokens");
      // Fallback to mock data
      setTokens(getMockTokens());
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTokens();
  }, []);

  const handleSortBy = (sortType) => {
    setSortFilter(sortType);

    // Sort tokens based on selection
    const sortedTokens = [...tokens].sort((a, b) => {
      switch (sortType) {
        case "APY %":
          return parseFloat(b.apy) - parseFloat(a.apy);
        case "Latest":
          return new Date(b.createdAt) - new Date(a.createdAt);
        case "Market Cap":
          return parseFloat(b.marketCap || 0) - parseFloat(a.marketCap || 0);
        case "Alphabetical":
          return a.fundName.localeCompare(b.fundName);
        default:
          return 0;
      }
    });

    setTokens(sortedTokens);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  // Filter tokens based on search term
  const filteredTokens = tokens.filter(
    (token) =>
      token.fundName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      token.assetType?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      token.assetClass?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Group tokens by asset type
  const tokensByAssetType = {
    "Real Estate": filteredTokens.filter(
      (token) => token.assetType === "Real Estate"
    ),
    "Treasuries & Bonds": filteredTokens.filter(
      (token) => token.assetType === "Treasuries & Bonds"
    ),
    "Private Credit": filteredTokens.filter(
      (token) => token.assetType === "Private Credit"
    ),
    Commodities: filteredTokens.filter(
      (token) => token.assetType === "Commodities"
    ),
    Equities: filteredTokens.filter((token) => token.assetType === "Equities"),
    Stocks: filteredTokens.filter((token) => token.assetType === "Stocks"),
  };

  // Helper function to format token data for display
  const formatTokenForDisplay = (token) => {
    return {
      id: token._id || token.id,
      logoImg: token.profileImage || getDefaultImage(token.assetType),
      cardTitle: token.fundName,
      cardImg: token.profileImage || getAssetImage(token.assetType),
      cardSubTitle: token.investmentStrategy || token.assetClass,
      description: token.description,
      details: [
        { label: "Asset Class", value: token.assetClass || token.assetType },
        { label: "Target Returns", value: token.targetReturns || "N/A" },
        { label: "Fund Term", value: token.fundTerm || "Open-ended" },
        {
          label: "Min.Invesment",
          value: `USD ${token.minInvestment?.toLocaleString() || "0"}`,
        },
      ],
      buttonText: "Invest Now",
      activeStatus: token.status === "active",
      tokenAddress: token.TokenAddress,
      apy: token.apy,
    };
  };

  // Default images based on asset type
  const getDefaultImage = (assetType) => {
    const defaultImages = {
      "Real Estate": "/assets/mrkt_card_icontop.webp",
      "Treasuries & Bonds": "/assets/mrktBond_icon.webp",
      "Private Credit": "/assets/mrktPrivate_icon.webp",
      Commodities: "/assets/mrktCommdty_icon.webp",
      Equities: "/assets/mrktEquity_icon.webp",
      Stocks: "/assets/mrktEquity_icon.webp",
    };
    return defaultImages[assetType] || "/assets/mrkt_card_icontop.webp";
  };

  const getAssetImage = (assetType) => {
    const assetImages = {
      "Real Estate": "/assets/market_card_img.webp",
      "Treasuries & Bonds": "/assets/mrktBond_card_img.webp",
      "Private Credit": "/assets/mrktPrivate_card_img.webp",
      Commodities: "/assets/mrktCommdty_card_img.webp",
      Equities: "/assets/mrktEquity_card_img.webp",
      Stocks: "/assets/mrktEquity_card_img.webp",
    };
    return assetImages[assetType] || "/assets/market_card_img.webp";
  };

  // Mock data fallback
  const getMockTokens = () => {
    return [
      {
        _id: "1",
        fundName: "Urbon Blocks",
        assetType: "Real Estate",
        assetClass: "Private Equity",
        description:
          "A flagship tokenized real estate fund, transforming premium properties into accessible digital tokens.",
        profileImage: "/assets/mrkt_card_icontop.webp",
        investmentStrategy: "Global Real Estate Fund",
        targetReturns: "10 - 12% p.a.",
        fundTerm: "Open-ended",
        minInvestment: 5000,
        apy: "12",
        status: "active",
        createdAt: new Date().toISOString(),
      },
      // Add more mock tokens as needed
    ];
  };

  return (
    <>
      <Header />

      <main className="main_flx">
        <Sidebar />

        {loading ? (
          // <div className="loading-overlay">
          //   <Oval
          //     color="#292B2C"
          //     secondaryColor="#D9D9D9"
          //     strokeWidth={2}
          //     height={75}
          //     width={75}
          //   />
          // </div>
          <>
            <MarketSkeleton />
          </>
        ) : (
          <div className="right_wrap market_wrap_main">
            <div className="market_tab_wrp">
              <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                {Object.keys(tokensByAssetType).map((assetType) => (
                  <li key={assetType} className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${
                        assetType === "Real Estate" ? "active" : ""
                      }`}
                      id={`pills-${assetType.replace(/\s+/g, "-")}-tab`}
                      data-bs-toggle="pill"
                      data-bs-target={`#pills-${assetType.replace(
                        /\s+/g,
                        "-"
                      )}`}
                      type="button"
                      role="tab"
                      aria-controls={`pills-${assetType.replace(/\s+/g, "-")}`}
                      aria-selected={assetType === "Real Estate"}
                    >
                      {assetType}
                    </button>
                  </li>
                ))}
              </ul>

              <div className="search_select_wrp">
                <div className="select_main">
                  <div className="dropdown">
                    <button
                      className="btn btn-secondary dropdown-toggle"
                      type="button"
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Sort by : <span>{sortFilter}</span>
                    </button>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      {["APY %", "Latest", "Market Cap", "Alphabetical"].map(
                        (option) => (
                          <li key={option}>
                            <a
                              className="dropdown-item"
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                handleSortBy(option);
                              }}
                            >
                              {option}
                            </a>
                          </li>
                        )
                      )}
                    </ul>
                  </div>
                </div>

                <div className="search_main">
                  <input
                    type="text"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={handleSearch}
                  />
                  <IoSearch />
                </div>
              </div>
            </div>

            {error && (
              <div className="alert alert-warning" role="alert">
                {error}
              </div>
            )}

            <div className="market_tab_content">
              <div className="tab-content" id="pills-tabContent">
                {Object.entries(tokensByAssetType).map(
                  ([assetType, assetTokens]) => (
                    <div
                      key={assetType}
                      className={`tab-pane fade ${
                        assetType === "Real Estate" ? "show active" : ""
                      }`}
                      id={`pills-${assetType.replace(/\s+/g, "-")}`}
                      role="tabpanel"
                      aria-labelledby={`pills-${assetType.replace(
                        /\s+/g,
                        "-"
                      )}-tab`}
                    >
                      {assetTokens.length === 0 ? (
                        <div className="no-tokens-message">
                          <img
                            src={
                              new URL(
                                "./../assets/no-invest.png",
                                import.meta.url
                              )
                            }
                            alt="No investments"
                            className="no_inv_img"
                          />

                          <p>
                            No {assetType} tokens found
                            {searchTerm && ` matching "${searchTerm}"`}
                          </p>
                        </div>
                      ) : (
                        <div className="dsh_inv_grid market_card_row">
                          {assetTokens.map((token) => {
                            const displayToken = formatTokenForDisplay(token);
                            return (
                              <div
                                key={displayToken.id}
                                className="dsh_inv_card market_card"
                              >
                                <div className="dsh_inv_head">
                                  <div className="dsh_inv_top mrkt_top_title">
                                    <div className="mrkt_top_content">
                                      <img
                                        className="img_div"
                                        src={displayToken.logoImg}
                                        alt={displayToken.cardTitle}
                                        onError={(e) => {
                                          e.target.src =
                                            getDefaultImage(assetType);
                                        }}
                                      />
                                      <h6>{displayToken.cardTitle}</h6>
                                    </div>
                                    {displayToken.activeStatus && (
                                      <span className="mrkt_sts">Active</span>
                                    )}
                                  </div>
                                  <img
                                    src={displayToken.cardImg}
                                    alt={displayToken.cardTitle}
                                    onError={(e) => {
                                      e.target.src = getAssetImage(assetType);
                                    }}
                                  />
                                  <div className="mrkt_main_cd_tlt">
                                    <h3>{displayToken.cardTitle}</h3>
                                    <h5>{displayToken.cardSubTitle}</h5>
                                    <p>{displayToken.description}</p>
                                  </div>

                                  <div className="dsh_inv_card_cnt">
                                    <div className="dsh_inv_cd_flx">
                                      {displayToken.details
                                        .slice(0, 2)
                                        .map((d, i) => (
                                          <div
                                            key={i}
                                            className="dsh_inv_cd_lft"
                                          >
                                            <span>{d.label}</span>
                                            <h4>{d.value}</h4>
                                          </div>
                                        ))}
                                    </div>
                                    <div className="dsh_inv_cd_flx mt-4">
                                      {displayToken.details
                                        .slice(2, 4)
                                        .map((d, i) => (
                                          <div
                                            key={i}
                                            className="dsh_inv_cd_lft"
                                          >
                                            <span>{d.label}</span>
                                            <h4>{d.value}</h4>
                                          </div>
                                        ))}
                                    </div>
                                  </div>
                                </div>
                                <button className="dsh_inv_btn">
                                  <Link
                                    to={{
                                      pathname: `/marketDetails/${displayToken.id}`,
                                      state: { token: displayToken },
                                    }}
                                  >
                                    {displayToken.buttonText}
                                  </Link>
                                </button>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  )
                )}
              </div>
            </div>

            <div className="mt-5">
              <Footer />
            </div>
          </div>
        )}
      </main>
    </>
  );
};

export default Market;
